export function hasOwnerRights(role) {
    return role === "owner";
}
export function isPermitted(role, permissionRole) {
    if (role === "none")
        return false;
    switch (permissionRole) {
        case "owner":
            return hasOwnerRights(role);
        case "admin":
            return role !== "member" && role !== "moderator";
        case "moderator":
            return role !== "member";
        case "member":
            return true;
    }
    return false;
}
